import { useCallback } from 'react';
import type { GoodsCoreModel, IScreensLogging } from 'shared/src/api/types';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import { bridge, isNotNil } from 'shared/src/utils';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';

type LogOnPressLikeParams = {
  logging: IScreensLogging;
  item: GoodsCoreModel;
  currentLike: boolean;
};

export const useOnPressLikeGoods = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ logging, item, currentLike }: LogOnPressLikeParams) => {
      const name = currentLike ? 'CLICK_UNLIKE_GOODS' : 'CLICK_LIKE_GOODS';

      logAnalyticsEvent({
        channel: ['firebase', 'amplitude', 'ablylog', 'facebook'],
        name,
        analytics: {
          ...logging.analytics,
        },
        ably_only_log: logging.ably_only_log,
      });

      if (isNotNil(item.ad)) {
        bridge.logAdEvent({
          action: currentLike ? AdAction.UNLIKE : AdAction.LIKE,
          ad: item.ad,
        });
      }
    },
    [logAnalyticsEvent],
  );
};
